export const styles = {
    margin: { margin: '4%' },
    paragraph: { fontSize: '20px', lineHeight: 'initial', textAlign: 'justify' },
    image: { textAlign: 'center' }
};